import React, { useState, Fragment } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UsersSelection from "../docsListing/addFolder/usersSelection";
import {
  addBuyerToTransaction,
  addSellerToTransaction,
  AddBuyerBroker,
  AddSellerBroker,
} from "../../../../redux/docs";
import { useDispatch } from "react-redux";
import ResponseAlert from "../../../../components/responseAlert";
import { toast } from "react-toastify";
function AddUserOnTransaction(props) {
  const { classes, open, setOpen, editDetail, id } = props;
  const [selected, setSelected] = useState(null);
  const [errors, setErrors] = useState({});
  
  const [errorAlert, setErrorAlert] = useState({
    errorMsg: "",
    errorType: "",
    isOpen: false,
  });

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };

  const handleSuccess = () => {
    handleClose();
    setErrorAlert({
      errorMsg: `You have successfully added the ${
        editDetail?.type || "buyer"
      } `,
      errorType: "success",
      isOpen: true,
    });
    toast.dismiss();
  };

  const handleError = (error) => {
    toast.dismiss();
    toast.error(JSON.stringify(error));
  };

  const handleAdd = () => {
    if (selected?.first_name) {
      if (editDetail?.type === "Buyer" || editDetail?.type === "add") {
        toast.loading(`Saving Buyer Info...`);
        dispatch(
          addBuyerToTransaction({
            id,
            schema: selected,
            handleSuccess,
            handleError,
          })
        );
      }
      if (editDetail?.type === "Seller" || editDetail?.type === "add") {
        toast.loading(`Saving Seller Info...`);
        dispatch(
          addSellerToTransaction({
            id,
            schema: selected,
            handleSuccess,
            handleError,
          })
        );
      }
      if (editDetail?.type === "Buyer Broker" || editDetail?.type === "add") {
        toast.loading(`Saving Buyer Broker Info...`);
        dispatch(
          AddBuyerBroker({
            id,
            schema: { ...selected, lead_id: undefined },
            handleSuccess,
            handleError,
          })
        );
      }
      if (editDetail?.type === "Seller Broker" || editDetail?.type === "add") {
        toast.loading(`Saving Seller Broker Info...`);
        dispatch(
          AddSellerBroker({
            id,
            schema: { ...selected, lead_id: undefined },
            handleSuccess,
            handleError,
          })
        );
      }
    } else {
      toast.warning(`Please select ${editDetail?.type}`, { theme: "colored" });
    }
  };

  return (
    <Fragment>
      {" "}
      <Dialog
        disablePortal
        sx={{ "& .MuiDialog-container": { mt: "30px" } }}
        open={open}
        onClose={handleClose}
        aria-labelledby="add-new-folder-model"
        aria-describedby="add-new-folder-model-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className={classes.modalHeader}>
          <Typography className={classes.modalHeading}>
            {editDetail?.action} {editDetail?.type}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {editDetail?.type === "Buyer" ||
          editDetail?.type === "Seller" ||
          editDetail?.type === "Seller Broker" ||
          editDetail?.type === "Buyer Broker" ? (
            <UsersSelection
              type={`${editDetail?.type}`}
              label={`${editDetail?.type} Name`}
              preOptions={[]}
              handleSelect={(value) => {
                console.log(value, "value");
                setSelected(value);
                setErrors((preErrors) => ({
                  ...preErrors,
                  useGridRowSelection: "",
                }));
              }}
              value={selected}
              errors={errors}
              disabled={false}
              setOpenUpdate={() => {}}
              setUpdateDetail={() => {}}
              labelType={editDetail?.type}
              multiple={false}
              {...props}
            />
          ) : null}
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            className={classes.cancelButton}
            color="inherit"
            variant="outlined"
            size="small"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={classes.updateButton}
            variant="contained"
            size="small"
            onClick={handleAdd}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <ResponseAlert
        open={errorAlert.isOpen}
        setOpen={() =>
          setErrorAlert({ errorMsg: "", errorType: "", isOpen: false })
        }
        alertType={errorAlert.errorType}
        alertMessage={errorAlert.errorMsg}
      />
    </Fragment>
  );
}

export default AddUserOnTransaction;
